import { logout } from './redux/actions/authActions';
import PageRoutes from './routes/PageRoutes';
import nProgress from 'nprogress';
import ToastComponent from './components/Toast/ToastComponent';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

function App() {
  nProgress.configure({ showSpinner: false });
  const dispatch = useDispatch();
  useEffect(() => {
    const handleStorageChange = (event) => {
      if (event.key === 'token' && event.oldValue && !event.newValue) {
        dispatch(logout());
      }
    };
    window.addEventListener('storage', handleStorageChange);
    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);
  return (
    <div className='App'>
      <PageRoutes />
      <ToastComponent />
    </div>
  );
}

export default App;
